import React from "react";
import uuid from "react-uuid";

import { StyledCard } from "../../../styles/pages/GestaoFaltas/GestaoFaltas";
import {
    StyledCardHour,
    StyledCardTeacher,
    StyledCardTitle,
} from "../../../styles/pages/AcademicActivityPlanStyles";
import StringUtils from "../../../utils/types/StringUtils";

type CardListProps = {
    name: string;
    date: string;
    children?: React.ReactNode;
};

const CardList: React.FC<CardListProps> = ({ name, date, children }) => {
    return (
        <StyledCard key={uuid()}>
            <div>
                <StyledCardTitle>Justificar TACH</StyledCardTitle>
                <StyledCardTeacher>{name}</StyledCardTeacher>
                <div>
                    <StyledCardHour>
                        {`Enviado em: ${StringUtils.formatDateString(
                            date,
                            "dd/MM/yyyy"
                        )}`}
                    </StyledCardHour>
                </div>
            </div>
            {children}
        </StyledCard>
    );
};

export default CardList;
